//export const BASE_URL ='http://localhost:5000/api/v1/';
//export const IMAGE_BASE_URL ='http://localhost:5000';

export const BASE_URL ='https://api.fundreach.co.ke/api/v1/';
export const IMAGE_BASE_URL ='https://api.fundreach.co.ke:8000';

/*ip:"154.159.237.122"
continentCode:"AF"
continentName:"Africa"
countryCode:"KE"
countryName:"Kenya"
countryNameNative:"Kenya"
officialCountryName:"Republic of Kenya"
regionCode:"30"
regionName:"Nairobi County"
cityGeoNameId:184745
city:"Nairobi"
cityWOSC:"Nairobi"
latitude:-1.2841
longitude:36.8155
capital:"Nairobi"
phoneCode:"254"
countryFlagEmoj:"🇰🇪"
countryFlagEmojUnicode:"U+1F1F0 U+1F1EA"
isEu:false
borders:["ETH","SOM","SSD","TZA","UGA"]
topLevelDomains:[".ke"]
languages:Object {}
en:Object {}
code:"en"
name:"English"
native:"English"
sw:Object {}
code:"sw"
name:"Swahili"
native:"Kiswahili"
currency:Object {}
code:"KES"
name:"Kenyan Shilling"
symbol:"KSh"
number:"404"
rates:Object {}
USDKES:128.45
EURKES:139.09
timeZone:Object {}
id:"Africa/Nairobi"
currentTime:"03/14/2025, 12:41:35 PM"
code:"EAT"
timeZoneName:"Eastern African Time"
utcOffset:10800
userAgent:Object {}
isMobile:false
isiPod:false
isTablet:false
isDesktop:true
isSmartTV:false
isRaspberry:false
isBot:false
browser:"Chrome"
browserVersion:"134.0.0.0"
operatingSystem:"Windows 10.0"
platform:"Microsoft Windows"
source:"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36"
connection:Object {}
asn:36926
isp:"Airtel Networks Kenya Limited"
descr:"CKL1-ASN, KE"
regCountry:"KE"
isActive:true
website:"www.airtelkenya.com"
type:"isp"
rir:"AFRINIC"
security:Object {}
isProxy:false
isBogon:false
isTorExitNode:false
isCloud:false
isHosting:false
isSpamhaus:false
suggestion:"allow"
network:"154.159.224.0/20"*/
